import { BRAND } from '../Data/brand';

export const CLIENT_NAME = BRAND.name;
export const CLIENT_TELEPHONE = BRAND.phone;
export const CLIENT_ADDRESS_LINES = BRAND.addressLines;
